// src/plugins/sentryPlugin.js
import { usePage } from '@inertiajs/vue3'
import * as Sentry from '@sentry/vue'
import { watch } from 'vue'

import type { Admin } from '@/types/generated.js'

export default {
  install(app) {
    const page = usePage<Admin.InertiaPageProps>()

    // try to get other authenticatables and set them here!?
    const updateUser = () => {
      const user = page.props?.auth?.user

      if (user) {
        Sentry.setUser({ email: user.email, id: user.id, name: user.name })
      } else {
        Sentry.setUser(null) // or clear the user
      }
    }

    // Watch for changes in the user state and update Sentry
    watch(
      () => page?.props,
      () => {
        updateUser()
      },
      { immediate: true },
    )

    const sentryRelease =
      document.querySelector('meta[name="app-release"]')?.getAttribute('content') ?? null

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
      environment: import.meta.env.VITE_APP_ENV,
      release: sentryRelease,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      tracesSampleRate: 0.01,
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.01,
      replaysOnErrorSampleRate: 1.0,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
        }),
      ],
    })

    // Initial user setup
    updateUser()
  },
}
